import MainImageBackground from "./MainImageBackground";
export default MainImageBackground;